import styled from '@emotion/styled';
import { useContext } from 'react';
import { store } from '../store';
import Grid from './Grid';
import Photo from './Photo';

const Paper = ({ paperRef }) => {
  const {
    paperWidth,
    paperHeight,
    paperWidthPx,
    paperHeightPx,
    border,
    grid,
    gridSecond,
    gridSize,
    gridSizeSecond,
    gridColor,
    gridColorSecond,
  } = useContext(store);
  const containerCols = border ? paperWidth / border : paperWidth;
  const containerRows = border ? paperHeight / border : paperHeight;

  return (
    <PaperEl
      ref={paperRef}
      width={paperWidthPx}
      height={paperHeightPx}
      cols={containerCols}
      rows={containerRows}
    >
      <Photo cols={containerCols} rows={containerRows} />
      {grid && (
        <>
          {gridSecond && <Grid size={gridSizeSecond} color={gridColorSecond} />}
          <Grid size={gridSize} color={gridColor} />
        </>
      )}
    </PaperEl>
  );
};

const PaperEl = styled.div(({ width = 100, height = 100, cols, rows }) => ({
  width,
  height,
  backgroundColor: '#FFFFEE',
  position: 'relative',
  display: 'grid',
  gridTemplateColumns: `repeat(${cols}, auto)`,
  gridTemplateRows: `repeat(${rows}, auto)`,
  marginTop: 20,
}));

export default Paper;
